<template>
  <el-config-provider :locale="locale">
    <router-view />
    <footer class="icp-footer">
      <a
        href="https://beian.mps.gov.cn/#/query/webSearch?code=44195202000239"
        rel="noreferrer"
        target="_blank"
        class="icp-link">
        <img src="/备案图标.png" alt="备案图标" class="icp-icon" />
        粤公网安备44195202000239号
      </a>
    </footer>
  </el-config-provider>
</template>

<script>
import { ElConfigProvider } from 'element-plus'
// ✅ 新版中文包导入方式（Element Plus v2.x）
import zhCn from 'element-plus/es/locale/lang/zh-cn'

export default {
  components: {
    [ElConfigProvider.name]: ElConfigProvider,
  },
  setup() {
    return {
      locale: zhCn, // 直接返回 zhCn
    }
  },
  created() {
    // 在页面刷新时将 vuex 状态存入 sessionStorage
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('messageStore', JSON.stringify(this.$store.state))
    })

    // 在页面加载时恢复 vuex 状态
    const savedState = sessionStorage.getItem('messageStore')
    if (savedState) {
      this.$store.replaceState(
        Object.assign(this.$store.state, JSON.parse(savedState))
      )
    }
  },
}
</script>

<style>
.icp-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  font-size: 12px;
  color: #909399;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: saturate(180%) blur(4px);
  border-top: 1px solid #ebeef5;
  z-index: 1000;
}
.icp-link {
  display: inline-flex;
  align-items: center;
  color: inherit;
  text-decoration: none;
}
.icp-link:hover {
  color: #606266;
}
.icp-icon {
  width: 16px;
  height: 16px;
  margin-right: 6px;
}
</style>
